module.exports = __webpack_public_path__ + "static/media/irori.0a2ac434.png";